<template>
  <label
    class="checkbox"
    :class="{ disabled: disabled, error: error }"
    @click="$emit('click', $event)"
  >
    <input
      type="checkbox"
      class="checkbox__input"
      v-model="isChecked"
      @change="change"
    />
    <div class="checkbox__fake"><icon name="ok" width="13" height="10" /></div>
    <div class="checkbox__text"><slot /></div>
  </label>
</template>

<script>
export default {
  name: "Checkbox",

  props: {
    value: {
      type: [Boolean, null],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isChecked: this.value
    };
  },

  methods: {
    change(event) {
      this.isChecked = event.target.checked ? true : null;
    }
  },

  watch: {
    value(val) {
      this.isChecked = val;
    },

    isChecked(value) {
      this.$emit("input", value);
    }
  }
};
</script>

<style lang="scss">
@import "@v2/app/styles/media";

.checkbox {
  display: inline-flex;
  color: #000;

  &__input {
    display: none;
  }

  &__fake {
    width: 24px;
    height: 24px;

    flex-shrink: 0;

    box-sizing: border-box;

    border: 1px solid #cdced0;

    border-radius: 2px;
    background-color: #ffffff;

    transition: all 0.3s;

    position: relative;

    .svg-icon--ok {
      position: absolute;
      left: 50%;
      top: 50%;

      transform: translate(-50%, -50%);
      transition: opacity 0.3s;

      opacity: 0;

      color: #0070d2;
    }
  }

  &.disabled {
    pointer-events: none;
  }

  &.disabled &__fake {
    background: rgba(241, 241, 241, 0.5);
  }

  &:not(.disabled):hover {
    cursor: pointer;

    &__fake {
      border-color: #a3a8b3;
    }
  }

  &.error &__fake {
    border-color: #ea5330;
  }

  &.error &__text {
    color: #ea5330;
  }

  &__input[disabled] + &__fake {
    background-color: rgba(241, 241, 241, 0.5);
  }

  &__input:checked + &__fake {
    .svg-icon--ok {
      opacity: 1;
    }
  }

  &__text {
    font-size: 13px;
    line-height: 1.54;
    color: inherit;
    margin-left: 12px;

    @include respond-down(md) {
      font-size: 12px;
    }
  }

  &.disabled &__text {
    color: #6d7179;
    opacity: 0.8;
  }
}
</style>
